import React, { useRef, useState, useEffect } from 'react'
import { get } from 'lodash'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Iframe from 'components/atoms/Iframe'
import CustomButton from 'components/atoms/CustomButton'
import { useSelector } from 'react-redux'

import './BennerApplication.scss'

function BennerApplication({ data, user, refs }) {
  const { external, uuid: id, url } = data
  const login = get(user, 'contract')
  const access_token = useSelector((state) => state.token?.token?.access_token)
  const profileCode = get(data, 'profile.entity.code')
  const baseUrl = process.env.RAZZLE_BENNER_BASE_URL
  const formAction = baseUrl + url
  const [headerHeight, setHeaderHeight] = useState(0)
  const formRef = useRef(null)

  const resize = () => {
    const temp = refs?.header?.current?.clientHeight || 50
    setHeaderHeight(temp + 50)
  }

  const handleSubmit = () => {
    formRef.current.submit()
  }

  useEffect(() => {
    resize()
  }, [])

  useEffect(() => {
    if (headerHeight) {
      if (!external) formRef.current.submit()
      window.addEventListener('resize', resize)
      setTimeout(resize, 100)
    }
  }, [headerHeight])

  return (
    <Container className="benner-aplication my-3">
      <Container>
        {headerHeight && (
          <>
            <form
              action={formAction}
              id={`form-benner-${id}`}
              method="post"
              target={`frame-benner-${id}`}
              ref={formRef}
            >
              <input type="hidden" name="TOKEN" value={access_token} />
              <input type="hidden" name="LOGIN" value={login} />
              <input type="hidden" name="PERFIL" value={profileCode} />
            </form>
            <Row>
              {external ? (
                <CustomButton className="my-3" target="_blank" onClick={handleSubmit} text="Acessar" iconAlign="right">
                  Acessar
                </CustomButton>
              ) : (
                <Iframe
                  className="benner-application__frame"
                  id={`frame-benner-${id}`}
                  name={`frame-benner-${id}`}
                  height={headerHeight}
                />
              )}
            </Row>
          </>
        )}
      </Container>
    </Container>
  )
}

export default BennerApplication
